import React from "react";
import {
  Typography,
  Box,
  useTheme,
  Paper,
  Chip,
  TableContainer,
  TableHead,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";
import {
  RectangleClinic,
  RectangleDistrict,
  RectangleMinistry,
  RectangleProvince,
} from "../../Svg";
import { Search as SearchIcon } from "@mui/icons-material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
const Transactions = () => {
  const theme = useTheme();
  const { state } = useLocation();

  const headings = [
    "Batch#",
    "Sender",
    "Receiver",
    "Quantity",
    "Type",
    "Transaction Type",
    "Expiry Date",
    "Storage Temprature",
    "Transaction Date",
  ];
  const transactions = [
    {
      senderRole: "ministry",
      receiverRole: "province",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Transfered",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
    {
      senderRole: "province",
      receiverRole: "district",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Expired",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
    {
      senderRole: "district",
      receiverRole: "clinic",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Used",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
    {
      senderRole: "clinic",
      receiverRole: "district",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Damaged",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
    {
      senderRole: "province",
      receiverRole: "district",
      batchNo: "12345",
      senderName: "QueensLand",
      receiverName: "Capital Hill",
      quantity: "5000",
      type: "Vaccine",
      transactionType: "Transfered",
      expiry: "04-09-2022",
      storageTemprature: "10 Degree",
      transferDate: "02-07-2022",
    },
  ];
  return (
    <Box>
      {" "}
      <Paper elevation={1} sx={{ paddingX: 3, paddingTop: 5 }}>
        <Box>
          <Typography
            variant="h5"
            sx={{ color: theme.palette.text.light, fontWeight: "bold" }}
          >
            {" "}
            Batch Details{" "}
          </Typography>
        </Box>
        <Box display={"flex"} flexDirection={"row"} gap={2}>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <RectangleMinistry />
            </Box>
            <Typography>Ministry</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <RectangleProvince />
            </Box>{" "}
            <Typography>Province</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <RectangleDistrict />
            </Box>{" "}
            <Typography>District</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexDirection={"column"}
            >
              <RectangleClinic />
            </Box>{" "}
            <Typography>Clinic</Typography>
          </Box>
        </Box>
        <Box display={"flex"} mr={2} justifyContent={"flex-end"} mt={2} mb={2}>
          <TextField
            size="small"
            type="search"
            placeholder="Search"
            // value={searched}
            // onChange={(e) => {
            //   setSearched(e.target.value);
            //   requestSearch(e.target.value);
            // }}
            InputProps={{
              startAdornment: (
                <SearchIcon
                  sx={{
                    color: theme.palette.primary.dark,
                  }}
                />
              ),
            }}
            sx={{
              borderRadius: 25,
              backgroundColor: theme.palette.secondary.dark,
              [`.${outlinedInputClasses.root}`]: {
                borderRadius: 25,
                paddingX: 2,
              },
            }}
          ></TextField>
        </Box>
        <TableContainer>
          <Table sx={{ marginTop: 3 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headings?.map((h, index) => (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                    }}
                    align="center"
                    key={`${index}-table-heading-${h}`}
                  >
                    <Chip
                      label={h}
                      sx={{
                        backgroundColor: theme.palette.secondary.dark,
                        borderRadius: 1,
                        color: theme.palette.primary.main,
                      }}
                    ></Chip>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {state?.vaccines?.all_transactions?.map((row, index) => (
                <TableRow key={`${index}-row.name-${index + 21}`}>
                  <TableCell align="center">{row?.reference_number}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: row,
                        minWidth: "120px",
                        gap: 0.5,
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        display={"flex"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                      >
                        {row?.sender_role === "ministry" ? (
                          <RectangleMinistry />
                        ) : row?.senderRole === "state" ? (
                          <RectangleProvince />
                        ) : row?.sender_role === "district" ? (
                          <RectangleDistrict />
                        ) : row?.sender_role === "hospital" ? (
                          <RectangleClinic />
                        ) : null}
                      </Box>
                      {row?.sender_name}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: row,
                        minWidth: "120px",
                        gap: 0.5,
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        display={"flex"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                      >
                        {row?.receiver_role === "ministry" ? (
                          <RectangleMinistry />
                        ) : row?.receiverRole === "state" ? (
                          <RectangleProvince />
                        ) : row?.receiver_role === "district" ? (
                          <RectangleDistrict />
                        ) : row?.receiver_role === "hospital" ? (
                          <RectangleClinic />
                        ) : null}
                      </Box>
                      {row?.receiver_name}
                    </Box>
                  </TableCell>
                  <TableCell align="center">{row?.quantity}</TableCell>
                  <TableCell align="center">{row?.main_type}</TableCell>
                  <TableCell align="center">
                    {" "}
                    <Chip
                      label={row?.transaction_type}
                      sx={{
                        backgroundColor:
                          row?.transaction_type === "issue" ||
                          row?.transaction_type === "used" ||
                          row?.transaction_type === "transfer"
                            ? "#00C851"
                            : row?.transaction_type === "expired"
                            ? "#FFBB33"
                            : "#FF4444",
                        borderRadius: 2,
                        minWidth: "80px",
                        color: theme?.palette?.text?.white,
                      }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {row?.expiry_date
                      ? format(new Date(row?.expiry_date), "MM/dd/yyyy")
                      : ""}
                  </TableCell>
                  <TableCell align="center">
                    {row?.storage_temprature.replace("_", " ")}
                  </TableCell>
                  <TableCell align="center">
                    {row?.transaction_date
                      ? format(new Date(row?.transaction_date), "MM/dd/yyyy")
                      : ""}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default Transactions;
